import type { ExternalTableSchema } from '@packages/table-builder';

export const drsRegistrationTable: ExternalTableSchema = {
  metadata: {
    title: 'List of DRS Registration',
    entity: 'DrsRegistration',
    description: 'View all DRS registration transfer-allocate containers.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/transfer-allocate-list-for-drs',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      SearchKeyWord: 'table.searchText',
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      ContainerStatusIds: 'filters.approvalStatusId',
    },
    filters: [
      {
        name: 'approvalStatusId',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/container-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      sortable: true,
      width: 200,
      visibility: 'locked',
    },
    {
      field: 'transferStatus',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 250,
      align: 'center',
      badge: {
        statusMap: {
          'Ready To Execute': 'primary',
          Allocated: 'success',
          Pending: 'info',
          'Pending broker': 'info',
          'Pending Broker': 'info',
          Failed: 'error',
          Draft: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'items',
      header: '#Items',
      type: 'text',
      sortable: true,
      width: 200,
      format: { decimals: 2, commas: true, fixed: true },
      fields: { formatAsNumber: 'true' },
      emptyDisplay: '-',
    },
    {
      field: 'noOfShares',
      header: '#Shares',
      type: 'text',
      sortable: true,
      width: 200,
      format: { decimals: 2, commas: true, fixed: true },
      fields: { formatAsNumber: 'true' },
      emptyDisplay: '-',
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      emptyDisplay: '-',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_DRS_REGISTRATION', label: 'View' },
      { id: 'EDIT_DRS_REGISTRATION', label: 'Edit' },
      { id: 'CHECK_TRANSFER_STATUS_DRS_REGISTRATION', label: 'Check Transfer Status' },
      { id: 'RETRY_DRS_REGISTRATION', label: 'Retry' },
      { id: 'DELETE_DRS_REGISTRATION', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_DRS_REGISTRATION',
        label: 'Create DRS Registration',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'DRS Registration',
      resizable: true,
      reorderable: true,
    },
  },
};
